module.exports = __webpack_public_path__ + "static/media/Table_After.056ffdac.jpg";